<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div class="comp-risk-ques comp">
        <el-row class="risk-test">
            <el-col class="risk-tit" :span="24">
                <div class="risk-tit-box">
                    <i class="risk-icon" />
                    <span>为了给您提供个性化的理财服务，我们需要对您的理财需求倾向进行评估，烦请完成如下问题，提交之后我们会向您公布测试结果。请仔细阅读下面题目，选出每个题目中最适合您的选项。</span>
                </div>
            </el-col>
            <el-col class="risk-ques" :span="24">
                <p class="ques-tit">
                    <span>{{ index }}</span>/{{ riskQuestions.length }}
                </p>
                <div class="ques-box">
                    <div class="ques-list">
                        <p class="ques-text">
                            {{ doQuestion.questionname }}
                        </p>
                        <el-radio-group v-if="doQuestion.multselect==='0'" v-model="answer">
                            <el-radio v-for="(an,_x) in doQuestion.ansList" :key="_x" :label="an.result">
                                {{ /[a-zA-Z]+$/.test(an.resultcontent.substr(0,2))?an.resultcontent:(an.result+'、'+an.resultcontent) }}
                            </el-radio>
                        </el-radio-group>
                        <el-checkbox-group v-if="doQuestion.multselect==='1'" v-model="answerArr">
                            <el-checkbox
                                v-for="(an,_y) in doQuestion.ansList"
                                :key="_y"
                                :label="an.result"
                            >
                                {{ an.resultcontent }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <el-row class="ques-next">
                        <el-pagination
                            background
                            :current-page.sync="index"
                            :page-size="1"
                            prev-text="上一题"
                            next-text="下一题"
                            layout="prev, next"
                            :total="riskQuestions.length"
                            v-on:current-change="questionRefresh"
                        />
                    </el-row>
                    <el-row v-if="riskQuestions.length>0" class="answer-list" :style="answerBoxStyle">
                        <el-col v-for="(list,_z) in riskQuestions" :key="_z" :span="12">
                            <div v-on:click="questionRefresh(_z+1)">
                                {{ _z+1 }}. <span>{{ list.key }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <!-- <div class="agree-content">
                    <el-checkbox v-model="checked">
                    </el-checkbox>
                    <span>本人已仔细阅读贵司的<a class="notice-read" v-on:click.prevent="read()">《投资者类型及风险匹配告知书》</a>，已充分知晓并理解贵司对本人的风险承受能力评估及产品等级匹配结果，本人对此没有异议。
                        <br />本人承诺，将及时、如实地向贵司告知本人的重大信息变更。
                    </span>
                </div> -->
                <div class="ques-btn">
                    <el-button type="primary" class="medium" v-on:click="submitForm()">
                        提交问卷
                    </el-button>
                </div>
            </el-col>
        </el-row>
        <el-dialog title="提示" :visible.sync="tpasswdDialogVisible" class="prop info-tips" width="480px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <p><i class="el-icon-warning" /><span>普通投资者转专业投资需要密码校验</span></p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item label="" prop="tpasswd">
                        <el-input
                            v-model="ruleForm.tpasswd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="tpasswdDialogVisible = false">
                    返回
                </el-button>
                <el-button type="primary" v-on:click="cancelConfirm">
                    确定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="(data.risk?'风险':'知识')+'评测提示'"
            :visible.sync="dialogVisible"
            class="prop"
            width="420px"
        >
            <div class="info-box">
                <el-alert :title="msg" type="warning" show-icon :closable="false" />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-if="passflag==='0'" v-on:click="$router.push({name:'info'})">
                    信息中心
                </el-button>
                <el-button type="primary" v-on:click="dialogVisible = false">
                    {{ btnMsg }}
                </el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="投资者类型及风险匹配告知书"
            :visible.sync="noticeDialogVisible"
            class="prop info-tips"
        >
            <div class="risk-confirm" style="line-height: 25px;">
                <p class="text-bold-style" style="font-weight: bold;">
                    尊敬的投资者，您好：
                </p>
                &emsp;&emsp;根据您填写的《个人投资者风险测评问卷》，您的风险承受能力测评得分为我司问卷最低分值，依据《证券期货投资者适当性管理办法》、《基金募集机构投资者适当性管理实施指引（试行）》相关规定，现对您进行是否属于C1（风险承受能力最低类别投资者）的判断，请问您是否符合以下情形？
                <el-radio-group v-model="riskConfirm">
                    <el-radio v-for="(item,_index) in confirmList" :key="_index" :label="item.result" style="display:block;text-indent:1em;margin-top:9px;">
                        {{ item.result + '. ' + item.content }}
                    </el-radio>
                </el-radio-group>
                <p class="text-bold-style text-indent-style" style="font-weight: bold;text-indent:2em;">
                    说明：
                </p>
                <p style="text-indent:2em;">
                    本问卷仅用于风险承受能力测评得分为我司问卷最低分值的投资者，判断其是否属于风险承受能力最低类别。符合A或B情形之一的自然人，被划分为C1（风险承受能力最低类别），仅适合购买风险等级为R1的产品，无法购买风险等级为R2、R3、R4、R5的产品。
                </p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="lowRiskCancel()">
                    返回
                </el-button>
                <el-button type="primary" v-on:click="makesureSubmit(true)">
                    确定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "RiskQues",
    props: {
        data: {
            type: Object,
            default: function () {
                return {
                    risk: true,
                    url: "risk"
                };
            }
        },
        fn: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            dialogVisible: false,
            agree: "",
            answer: "",
            answerArr: [],
            btnMsg: "",
            index: 1,
            query: null, // 定时器对象
            riskQuestions: [],
            doQuestion: {},
            msg: "",
            passflag: "",
            checked: true,
            noticeDialogVisible: false,
            // 密码校验
            ruleForm: {
                tpasswd: ""
            },
            rules: {
                tpasswd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            tpasswdDialogVisible: false,
            answerBoxStyle: {}, //答案列表top样式
            riskConfirm: "", //最低风险承受确认
            confirmList: [
                {result: "A", content: "本人不具有完全民事行为能力"},
                {result: "B", content: "本人没有风险容忍度或者不愿承受任何投资损失"},
                {result: "C", content: "以上都不是"}
            ],
            allResult: "",
            allPoint: ""
        };
    },
    watch: {
        answer (val) { // 监听答案更新数据
            if (val && val !== "") {
                const _this = this;
                if (this.index < this.riskQuestions.length && val !== this.riskQuestions[this.index - 1].key) { // 自动跳到下一题
                    this.query = setTimeout(function () {
                        _this.questionRefresh(_this.index + 1);
                    }, 100);
                }
                this.$set(this.riskQuestions[this.index - 1], "key", val);
            }
        },
        answerArr (val) {
            if (val && val.length > 0) {
                this.$set(this.riskQuestions[this.index - 1], "key", val.join(","));
            }
        }
    },
    created () {
        this.getRisks();
    },
    methods: {
        submitForm () {
            const _this = this;
            let _notDo = [];

            this.allResult = "";
            this.allPoint = "";
            for (let _x in this.riskQuestions) {
                const _r = this.riskQuestions[_x].key;
                if (!_r) {
                    _notDo.push(Number(_x) + 1);
                }else{
                    this.allResult += this.riskQuestions[_x].questioncode + ":" + _r + "|";
                    const _a = this.riskQuestions[_x].ansList;
                    let point = [];
                    for (let _z in _a) {
                        if (_r.indexOf(_a[_z].result) > -1) {
                            point.push(_a[_z].resultpoint);
                        }
                    }
                    this.allPoint += point.join(",") + "|";
                }
            }
            if (_notDo.length > 0) {
                this.msg = "您还有第" + _notDo.join(",") + "题(共" + _notDo.length + "题)没有回答!";
                this.btnMsg = "我已知晓";
                this.dialogVisible = true;
            } else if(this.data.risk){
                this.$util.request("acct/risksurvey/preview", { answer: this.allResult.substr(0, this.allResult.length - 1), pointlist: this.allPoint.substr(0, this.allPoint.length - 1), papercode: this.riskQuestions[0].papercode, iscontinue: "1" }, "POST").then(res => {
                    if (res.data){
                        if(res.data[0].risklevel == "01"){ //风险测评等级为最低风险承受能力的C1
                            this.noticeDialogVisible = true;
                        }else{
                            this.makesureSubmit();
                        }
                    }
                });
            } else{
                this.makesureSubmit();
            }
        },
        makesureSubmit (flag = false) {
            const _this = this;
            let lowriskflag = "0";
            if(flag){
                if(this.riskConfirm){
                    lowriskflag = this.riskConfirm == "C" ? "0" : "1";
                }else{
                    this.$message({
                        type: "warning",
                        message: "你还未做出选择，请先选择再点击确定！"
                    });
                    return;
                }
            }
            const reqUrl = "acct/" + (this.data.risk ? "risksurvey" : "changetype") + "/answer";
            this.$util.request(reqUrl, { answer: this.allResult.substr(0, this.allResult.length - 1), pointlist: this.allPoint.substr(0, this.allPoint.length - 1), papercode: this.riskQuestions[0].papercode, iscontinue: "1", lowriskflag: lowriskflag }, "POST").then(res => {
                if (res.data) {
                    _this.noticeDialogVisible = false;
                    if (_this.data.risk) {
                        const info = _this.$cache.getUser();
                        info.riskexpired = "0";
                        info.custrisk = res.data[0].risklevel;
                        info.lowriskflag = res.data[0].lowriskflag;
                        _this.$store.dispatch("setInfo", info).then(() => {
                            if (_this.fn) { _this.$emit("fn-back", false); } else {
                                _this.$router.push({ name: _this.data.url, query: { iswarn: res.data[0].iswarn } });
                            }
                        });
                    } else {
                        _this.passflag = res.data[0].passflag;
                        if (_this.passflag === "1") {
                            if (_this.$cache.getPwdCheck("P2")) {
                                _this.ruleForm.tpasswd = "";
                                _this.tpasswdDialogVisible = true;
                            }else {
                                _this.toProfessional();
                            }
                        } else {
                            _this.msg = "您的投资者知识评测未达到要求";
                            _this.btnMsg = "重新评测";
                            _this.dialogVisible = true;
                        }
                    }
                }
            });
        },
        lowRiskCancel(){
            this.noticeDialogVisible = false;
            this.riskConfirm = "";
        },
        cancelConfirm () {
            var _this = this;
            _this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    _this.tpasswdDialogVisible = false;
                    _this.toProfessional();
                }else {
                    return false;
                }
            });
        },
        toProfessional () {
            var _this = this;
            this.$util.request("acct/changetype/ordinary2professional", {"tradepwd": _this.$util.enc(_this.ruleForm.tpasswd)}, "POST").then(res => {
                if (res.data) {
                    _this.ruleForm.tpasswd = "";
                    _this.$router.push({name: _this.data.url});
                }
            });
        },
        // 刷新题目数据
        questionRefresh (val) {
            /* if(this.index === val){
                    return;
                } */
            clearTimeout(this.query);
            this.index = val;
            const _d = this.riskQuestions[this.index - 1];
            this.answerBoxStyle = {top: "13%"}; //风险测评题目长度只占一行时
            if (_d.questionname.length > 70){ // 题目长度大于70个字，即题目长度超过一行时，重新计算top高度
                let top = 15;
                const rowNum = _d.questionname.length / 70;
                top += 5 * Math.round(rowNum);
                console.log( rowNum,top,"rowNum");
                this.answerBoxStyle = {top: top + "%"};
            }
            this.doQuestion = _d;
            this.answer = _d ? _d.key : "";
            this.answerArr = _d && _d.key && _d.key.length > 0 ? _d.key.split(",") : [];
        },
        // 获取题目信息
        getRisks () {
            const _this = this;
            const reqUrl = "acct/" + (this.data.risk ? "risksurvey" : "changetype") + "/question";
            this.$util.request(reqUrl).then(res => {
                if (res.data) {
                    let _obj = {};
                    // 整理题目数据格式
                    for (let arr of res.data) {
                        if (_obj[arr.questioncode]) {
                            let _d = {
                                result: arr.result,
                                resultcontent: arr.resultcontent,
                                resultpoint: arr.resultpoint
                            };
                            for (let _x of _this.riskQuestions) {
                                if (_x.questioncode === arr.questioncode) {
                                    _x.ansList.push(_d);
                                }
                            }
                        } else {
                            _obj[arr.questioncode] = true;
                            let _d = {
                                result: arr.result,
                                resultcontent: arr.resultcontent,
                                resultpoint: arr.resultpoint
                            };
                            arr.ansList = [];
                            arr.ansList.push(_d);
                            _this.riskQuestions.push(arr);
                        }
                    }
                    _this.questionRefresh(_this.index);
                }
            });
        }
    }
};
</script>
<style lang="scss">
    @import "../../assets/css/varibles";
    .comp-risk-ques {
    .risk-test {
    .el-pagination span:not([class*="suffix"]),
    .el-pagination button {
        height: 32px;
        width: 68px;
        line-height: 32px;
        background: transparent;
        border-radius: 3px;
    }
    .el-pagination {
        padding: 0;
    }
    .el-pagination button {
        border: 1px solid $text-color10;
    &:first-of-type {
         margin-left: 0;
     }
    &.btn-prev {
    &:hover,
    &:focus {
         border-color: $color-a;
         color: $color-a;
     }
    &:disabled {
         color: $text-color10;
         border-color: $text-color10;
     }
    }
    &.btn-next {
         color: $color-a;
         background: $color-a-l;
         border-color: $color-a-ld;
    &:hover,
    &:focus {
         border-color: $color-a;
         background: $color-a;
         color: $text-color6;
     }
    &:disabled {
         color: $text-color10;
         border-color: $text-color10;
     }
    }
    }
    padding: 0 20px;
    .risk-tit {
        margin: 20px 0 10px;
    .risk-tit-box {
        background-color: $bg10;
        border: 1px solid $border-color6;
        padding: 8px 10px;
    .risk-icon {
        width: 42px;
        height: 48px;
        display: inline-block;
        vertical-align: middle;
        background: url($icon) -297px -122px no-repeat;
        margin-right: 13px;
    }
    span {
        display: inline-block;
        vertical-align: middle;
        line-height: 24px;
        color: $text-color3;
        width: 1076px;
    }
    }
    }
    .risk-ques {
    .ques-tit {
    span {
        font-size: $f30;
        color: $color-b;
    }
    font-size: $f18;
    color: $text-color1;
    line-height: 40px;
    }
    .ques-tit,
    .ques-box {
        border-bottom: 1px solid $border-color8;
    }
    .ques-next {
        margin: 10px 0 20px 24px;
    }
    .ques-box {
        position: relative;
    .answer-list {
        width: 200px;
        position: absolute;
        top: 13%;
        right: 5%;
        background-color: $color-a-l;
        padding: 10px;
        border-radius: 6px;
        font-size: $f16;
        color: $text-color3;
    .el-col {
        line-height: 26px;
        cursor: pointer;
        border-radius: 3px;
        padding: 0 4px;
    span {
        color: $color-b;
    }
    &:hover {
         background-color: $color-a-ld;
     }
    }
    }
    .ques-list {
        padding: 10px 0;
        color: $text-color2;
    .ques-text {
        font-size: $f16;
        line-height: 36px;
    }
    .el-radio-group,
    .el-checkbox-group {
        width: 75%;
        margin: 7px 0 10px 24px;
    .el-radio{
         display: block;
         white-space: normal;
    }
    .el-checkbox {
        display: block;
    }
    .el-checkbox__label {
        white-space: normal;
        font-size: 16px!important;
        color: #333333;
    }
    .is-checked .el-checkbox__label {
        color: #e60012!important;
     }
    .el-checkbox__input {
        vertical-align: top;
    }
    .el-radio,.el-checkbox:last-child{
        margin-right: 30px;
    }
    .el-radio + .el-radio,
    .el-checkbox + .el-checkbox {
        margin-left: 0;
        margin-top: 9px;
    }
    }
    }
    }
    .ques-btn {
        padding: 10px 0 0 24px;
    .el-checkbox-group {
        margin: 10px 0;
    }
    }
    .agree-content {
        padding: 15px 20px;
    >label {
        margin-right: 7px;
    }
    .notice-read {
        cursor: pointer;
    }
    }
    }
    }
    }
</style>
